import styled from 'styled-components';

import { Tag } from '@xingternal/tag';
import { spaceXS, spaceXXL } from '@xingternal/tokens';

export const StyledTag = styled(Tag)`
  width: fit-content;
  margin: 5px;
  max-width: 100%;
`;

export const StyledTagGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const StyledTagGroupWithHeadline = styled.div`
  margin-top: ${spaceXXL};
  margin-bottom: ${spaceXS};
`;
